import axios from "axios";
import authHeader from "./auth-header";
import { apiUrl } from "../constant";
// Test api url
const API_URL = "http://localhost:5000/api/";

const getCompany = () => {
  return axios.get(API_URL + "company", { headers: authHeader() });
};

const getcompanybyId = (Id) => {
  return axios.get(API_URL + "company/" + Id, {
    headers:
      authHeader()
  });
};

const deletecompanybyId = (Id) => {
  return axios.delete(API_URL + "company/?Id=" + Id, {
    headers:
      authHeader()
  });
};

const getUserRoleService = () => {
  return axios.get(`${apiUrl}/GetRoleList`);
};

export const getAllFilterCompanyService = (data) => {
  return axios.post(`${apiUrl}/api/company-filter`, data);
};
export const getAllSellerService = (data) => {
  return axios.post(`${apiUrl}/api/GetAllSeller`, data);
};

export const exportCompanySellersService = (data) => {
  return axios.post(`${apiUrl}/api/company/ExportCompanySellers`, data, {
    responseType: 'blob',
  });
};

export const getAllSellerFilterService = (data) => {
  return axios.post(`${apiUrl}/api/seller-filter`, data);
};

export const getAllServicesService = (data) => {
  return axios.post(`${apiUrl}/api/company/GetAllServices`, data, {
    headers: {
      'Content-Type': 'application/json-patch+json',
      accept: '*/*',
    },
  });
};

export const getSubServiceTypesByIdService = (data) => {
  return axios.post(`${apiUrl}/api/company/GetSubServiceTypesById`, data, {
    headers: {
      'Content-Type': 'application/json-patch+json',
      accept: '*/*',
    },
  });
};

export const getSkuByIdService = (data) => {
  return axios.post(`${apiUrl}/api/company/GetSkuById`, data, {
    headers: {
      'Content-Type': 'application/json-patch+json',
      accept: '*/*',
    },
  });
};

export const getCarrierConnectIdsService = (data) => {
  return axios.post(`${apiUrl}/api/CarrierConnect/GetCarrierConnectIds`, data, {
    headers: {
      'Content-Type': 'application/json-patch+json',
      accept: '*/*',
    },
  });
};

export const updatePermissionService = (data) => {
  return axios.put(`${apiUrl}/api/updatepermission`, data);
};

export const getAllEmployeePermissionService = () => {
  return axios.get(`${apiUrl}/api/allemployeepermission`);
};

export const getPackingLabelsService = (data) => {
  return axios.post(`${apiUrl}/api/getPackingLabels`, data);
};

export const getShippedLabelHistoryService = (data) => {
  return axios.post(`${apiUrl}/api/GetShippedLabelHistory`, data);
};

export const getAllTaskPriorityService = () => {
  return axios.get(`${apiUrl}/api/TaskManagement/GetAllTaskPriority`);
};

export const getAllTaskStatuService = () => {
  return axios.get(`${apiUrl}/api/TaskManagement/GetAllTaskStatus`);
};

export const getAllTaskTypeService = () => {
  return axios.get(`${apiUrl}/api/TaskManagement/GetAllTaskType`);
};

export const getAllTaskListingService = (data) => {
  return axios.post(`${apiUrl}/api/TaskManagement/GetAllTasks`, data);
};

export const getAllPackageTasksService = (data) => {
  return axios.post(`${apiUrl}/api/TaskManagement/GetAllPackageTasks`, data);
};

export const getAllProductTasksService = (data) => {
  return axios.post(`${apiUrl}/api/TaskManagement/GetAllProductTasks`, data);
};

export const getAllTasksByTypeService = (data) => {
  return axios.post(`${apiUrl}/api/TaskManagement/GetAllTasksByType`, data);
};

export const debitPackageCostService = (data) => {
  return axios.post(`${apiUrl}/api/IncomingPackage/DebitPackageCost`, data);
};

export const taskChargesHistoryByPackageIdService = (data) => {
  return axios.post(`${apiUrl}/api/IncomingPackage/TaskChargesHistoryByPackageId`, data);
};

export const debitProductCostService = (data) => {
  return axios.post(`${apiUrl}/api/IncomingProduct/DebitProductCost`, data);
};

export const taskChargesHistoryByProductIdService = (data) => {
  return axios.post(`${apiUrl}/api/IncomingProduct/TaskChargesHistoryByProductId`, data);
};

export const getSellerWarehouseService = (data) => {
  return axios.post(`${apiUrl}/api/Accounts/GetSellerWarehouse`, data, { headers: authHeader() });
};

export const getSellersByCompanyIdsService = (data) => {
  return axios.post(`${apiUrl}/api/GetSellersByCompanyIds`, data);
};

export const getAllActiveCompanySellersService = () => {
  return axios.get(`${apiUrl}/GetAllActiveCompanySellersAsync`, { headers: authHeader() });
};

export const getFirstAdminUserByCompanyIdService = (companyId) => {
  return axios.get(`${apiUrl}/api/Company/GetFirstAdminUserByCompanyId?companyId=${companyId}`, { headers: authHeader() });
};

export default {
  getCompany,
  getcompanybyId,
  deletecompanybyId,
  getUserRoleService,
  getAllSellerService,
  getAllSellerFilterService,
  getAllServicesService,
  getSubServiceTypesByIdService,
  getSkuByIdService,
  getCarrierConnectIdsService,
  getAllFilterCompanyService,
  getShippedLabelHistoryService,
  getSellerWarehouseService,
  getAllActiveCompanySellersService,
};